import { createFileRoute } from '@tanstack/react-router';

import { useFieldLayout } from '../hooks/useMedia';
import ToolFundDashboard from '../modules/ToolFundDashboard/main';
import { ToolFundDashboardPhone } from '../modules/ToolFundDashboard/phone/admin/ToolFundDashboardPhone';

export const Route = createFileRoute('/toolFundDashboard')({
  component: RouteComponent,
  head(ctx) {
    return {
      meta: [{ title: 'Tool Fund Dashboard' }],
    };
  },
});

function RouteComponent() {
  const isFieldLayout = useFieldLayout();
  if (isFieldLayout) {
    return <ToolFundDashboardPhone />;
  }
  return <ToolFundDashboard />;
}
